<template>
	<div v-click-outside="closeMenu" class="sub-menu">
		<h4 v-if="heading" class="heading">{{heading}}</h4>
		<ul v-if="items">
			<li v-for='item in items' class="sub-menu-item" :class="{disabled: item.disabled}">
				<!-- For paid features (freemium users): use plain anchor to block navigation; router-link would navigate before we can prevent it -->
				<a v-if="'link' in item && itemClickable(item) && showPaidFlag(item)" href="#" v-on:click.prevent="linkClick(item)">
					<i v-if="'icon' in item" class="fa fa-fw fa-lock" style="margin-right: 2px"></i>
					<template v-if="'text' in item">{{item.text}}</template>
					<template v-else>{{item.label}}</template>
				</a>
				<router-link v-else-if="'link' in item && itemClickable(item)" :to="item.link" v-on:click.native="linkClick(item)">
					<i v-if="'icon' in item" class="fa fa-fw" :class="item.icon" style="margin-right: 2px"></i>
					<template v-if="'text' in item">{{item.text}}</template>
					<template v-else>{{item.label}}</template>
				</router-link>
				<a v-else-if="'path' in item && itemClickable(item) && showPaidFlag(item)" href="#" v-on:click.prevent="linkClick(item)">
					<i v-if="'icon' in item" class="fa fa-fw fa-lock" style="margin-right: 2px"></i>
					<template v-if="'text' in item">{{item.text}}</template>
					<template v-else>{{item.label}}</template>
				</a>
				<router-link v-else-if="'path' in item && itemClickable(item)" :to="item.path" v-on:click.native="linkClick(item)">
					<i v-if="'icon' in item" class="fa fa-fw" :class="item.icon" style="margin-right: 2px"></i>
					<template v-if="'text' in item">{{item.text}}</template>
					<template v-else>{{item.label}}</template>
				</router-link>
				<div v-else v-on:click="itemClicked(item)">
					<i v-if="'icon' in item" class="fa fa-fw" :class="showPaidFlag(item) ? 'fa-lock' : item.icon" style="margin-right: 2px"></i>
					<template v-if="'text' in item">{{item.text}}</template>
					<template v-else>{{item.label}}</template>
				</div>
			</li>
		</ul>
		<slot></slot>
	</div>
</template>
<script type="text/javascript">
import CustomDirectives from "@/mixins/CustomDirectives.js"

export default {
	name: "SubMenu",
	mixins: [CustomDirectives],
	props: ["heading",'items'],
	data() {
		return {
			clickOutsideActive: false
		}
	},
	methods: {
		closeMenu() {
			if (this.clickOutsideActive)
				this.$emit("closeMenu")
		},
		linkClick(item) {
			// For freemium users, block navigation to paid features and show upgrade message
			if (this.showPaidFlag(item)) {
				this.throwPremiumFeatureError()
				return
			}
			this.$emit("linkClick", item)
		},
		itemClickable(item) {
			return !("disabled" in item) || !item.disabled
		},
		itemClicked(item) {
			if (this.itemClickable(item))
				this.$emit('itemClick',item)
		},
		showPaidFlag(item) {
			if (this.isFreemiumUser && (!("freemiumTier" in item) || !item.freemiumTier))
				return true

			return false
		}
	},
	computed: {
		
	},
	created() {
		let vm = this
		setTimeout(() => {
			vm.clickOutsideActive = true
		},200)
	}
}
</script>

<style type="text/css" scoped>

	.sub-menu {
		position: absolute;
		right: 0;
		top: 45px;
		margin: 0;
		background-color: #fff;
		color: #455A64;
		width: 236px;
		border:1px solid #e0e0e0;
		box-shadow: 0 2px 5px rgba(10,10,10,0.2);
		z-index: 35;
		overflow-y: auto;
		max-height: calc(100vh - 60px);
	}

	.sub-menu ul {
		list-style: none;
		padding: 0;
		margin: 0;
	}

	.sub-menu-item {
		padding: 10px;
		text-align: left;
		color: #455A64;
		border-bottom: 1px solid #e0e0e0;
		position: relative;
	}

	.sub-menu-item a {
		display: block;
		color: inherit;
		text-decoration: none;
	}

	.sub-menu-item:hover, a.btn:hover {
		background-color: #e2ecf1;
		cursor: pointer;
	}

	.sub-menu-item.disabled {
		color: gray;
	}

	.sub-menu-item.disabled:hover {
		cursor: initial;
		background-color: inherit;
	}

	h4.heading {
		text-align: left;
		padding: 5px;
		font-size: 12pt;
		font-weight: bold;
		color: #455A64;
		border-bottom: 1px solid #e0e0e0;
		text-decoration: none;
		margin-bottom: 0;
	}
</style>